const mockComponents = {
  pages: {
    Main: [
      'Marquee',
      'SingleBanner',
      'BannerGrid',
      'BannerSlider',
      'CarouselBanner',
      'CollectionGrid',
      'CollectionSlider',
      'SingleProduct',
      'ProductGrid',
      'ProductSlider',
      'ProductList',
      'Search',
      'RichText',
      'Timer',
      'ImageHotspot',
      'Divider',
      'Button',
      'Announcement',
      'SocialLink',
      'FAQ',
      'GoogleMap',
      'Webview',
      'CategoryChips',
      'BlogCard',
      'FilteredProductSlider',
      'MenuList',
    ],
    Category: [
      'Marquee',
      'SingleBanner',
      'BannerGrid',
      'BannerSlider',
      'CarouselBanner',
      'CollectionGrid',
      'CollectionSlider',
      'CollectionList',
      'SingleProduct',
      'ProductGrid',
      'ProductSlider',
      'ProductList',
      'Search',
      'RichText',
      'Timer',
      'ImageHotspot',
      'Divider',
      'Button',
      'Announcement',
      'SocialLink',
      'FAQ',
      'GoogleMap',
      'CategoryChips',
      'MenuList',
      'BlogCard',
      'FilteredProductSlider',
    ],
    BeforeSearch: [
      'Marquee',
      'SingleBanner',
      'BannerGrid',
      'BannerSlider',
      'CarouselBanner',
      'CollectionGrid',
      'CollectionSlider',
      'CollectionList',
      'SingleProduct',
      'ProductGrid',
      'ProductSlider',
      'ProductList',
      'Search',
      'RichText',
      'Timer',
      'ImageHotspot',
      'Divider',
      'Button',
      'Announcement',
      'SocialLink',
      'FAQ',
      'GoogleMap',
      'CategoryChips',
      'BlogCard',
      'FilteredProductSlider',
    ],
    AfterSearch: ['Search', 'ProductGrid'],
    Checkout: ['Checkout'],
    Profile: ['Profile'],
    ProfileSettings: ['ProfileSettings'],
    ProfileAddress: ['ProfileAddress'],
    ProfileLanguages: ['ProfileLanguages'],
    ProfilePolicies: ['ProfilePolicies'],
    ProfileOrders: ['ProfileOrders'],
    ProductList: [
      'ProductGrid',
      'Marquee',
      'SingleBanner',
      'BannerGrid',
      'BannerSlider',
      'CarouselBanner',
      'CollectionGrid',
      'CollectionSlider',
      'CollectionList',
      'SingleProduct',
      'ProductSlider',
      'ProductList',
      'Search',
      'RichText',
      'Timer',
      'ImageHotspot',
      'Divider',
      'Button',
      'Announcement',
      'SocialLink',
      'FAQ',
      'GoogleMap',
      'CategoryChips',
      'MenuList',
      'BlogCard',
      'FilteredProductSlider',
    ],
    ProductDetail: [
      'ProductDetailImage',
      'ProductDetailVariants',
      'ProductDetailDescription',
      'ProductDetailAttributes',
      'ProductDetailComments',
      'ProductDetailAddCart',
      'ProductDetailComplementaryProduct',
      'Marquee',
      'SingleBanner',
      'BannerGrid',
      'BannerSlider',
      'CarouselBanner',
      'CollectionGrid',
      'CollectionSlider',
      'SingleProduct',
      'ProductGrid',
      'ProductSlider',
      'ProductList',
      'Search',
      'RichText',
      'Timer',
      'ImageHotspot',
      'Divider',
      'Button',
      'Announcement',
      'SocialLink',
      'FAQ',
      'GoogleMap',
      'Webview',
      'CategoryChips',
      'ProductDetail',
      'BlogCard',
      'FilteredProductSlider',
    ],
    SignIn: ['SignIn'],
    SignUp: ['SignUp'],
    FrontPage: ['FrontPage'],
    Favorites: ['ProductGrid'],
    ForgotPassword: ['ForgotPassword'],
    appBar: ['AppBar'],
    bottomBar: ['BottomBar'],
    generalStyle: ['generalStyle'],
    Notification: ['Notification'],
    Cart: [
      'Marquee',
      'SingleBanner',
      'BannerGrid',
      'BannerSlider',
      'CarouselBanner',
      'CollectionGrid',
      'CollectionSlider',
      'SingleProduct',
      'ProductGrid',
      'ProductSlider',
      'ProductList',
      'Search',
      'RichText',
      'Timer',
      'ImageHotspot',
      'Divider',
      'Button',
      'Announcement',
      'SocialLink',
      'FAQ',
      'GoogleMap',
      'Webview',
      'CategoryChips',
      'CargoBar',
      'Cart',
      'ContinueOrder',
      'BlogCard',
      'FilteredProductSlider',
    ],
    Popup: ['Popup'],
    QuickBuyModal: ['QuickBuyModal'],
  },
  defaultPages: {
    Main: {
      type: 'dnd',
      isSectionsIncrementable: true,
    },
    Category: {
      type: 'dnd',
    },
    BeforeSearch: {
      components: [
        {
          type: 'Search',
          id: 'Search_qr',
        },
      ],
      type: 'dnd',
    },
    AfterSearch: {
      components: [
        {
          type: 'Search',
          id: 'Search_1',
        },
        {
          type: 'ProductGrid_1',
          id: 'ProductGrid_1',
        },
      ],
      type: 'dnd',
    },
    Cart: {
      components: [
        {
          type: 'CargoBar',
          id: 'CargoBar_1',
        },
        {
          type: 'Cart',
          id: 'Cart_1',
        },
        {
          type: 'ContinueOrder',
          id: 'ContinueOrder_1',
        },
      ],
      type: 'dnd',
    },
    Profile: {
      components: [
        {
          type: 'Profile',
          id: 'Profile_1',
        },
      ],
      type: 'selectable',
    },
    ProfileSettings: {
      components: [
        {
          type: 'ProfileSettings',
          id: 'ProfileSettings_1',
        },
      ],
      type: 'selectable',
    },
    ProfileAddress: {
      components: [
        {
          type: 'ProfileAddress',
          id: 'ProfileAddress_1',
        },
      ],
      type: 'selectable',
    },
    ProfileLanguages: {
      components: [
        {
          type: 'ProfileLanguages',
          id: 'ProfileLanguages_1',
        },
      ],
      type: 'selectable',
    },
    ProfilePolicies: {
      components: [
        {
          type: 'ProfilePolicies',
          id: 'ProfilePolicies_1',
        },
      ],
      type: 'selectable',
    },
    ProfileOrders: {
      components: [
        {
          type: 'ProfileOrders',
          id: 'ProfileOrders_1',
        },
      ],
      type: 'selectable',
    },
    ProductList: {
      components: [
        {
          type: 'ProductGrid',
          id: 'ProductGrid_1',
        },
      ],
      type: 'dnd',
    },
    ProductDetail: {
      components: [
        {
          type: 'ProductDetail',
          id: 'Image_1',
        },
        {
          type: 'ProductDetailAttributes_1',
          id: 'ProductDetailAttributes',
        },
        {
          type: 'ProductDetailComments',
          id: 'Comments_1',
        },
        {
          type: 'ProductDetailAddCart',
          id: 'AddCart_1',
        },
      ],
      type: 'dnd',
    },
    SignIn: {
      components: [
        {
          type: 'SignIn',
          id: 'SignIn_1',
        },
      ],
      type: 'selectable',
    },
    SignUp: {
      components: [
        {
          type: 'SignUp',
          id: 'SignUp_1',
        },
      ],
      type: 'selectable',
    },
    FrontPage: {
      components: [
        {
          type: 'FrontPage',
          id: 'FrontPage_1',
        },
      ],
      type: 'selectable',
    },
    Favorite: {
      components: [
        {
          type: 'ProductGrid',
          id: 'ProductGrid_1',
        },
      ],
      type: 'selectable',
    },
    ForgotPassword: {
      components: [
        {
          type: 'ForgotPassword',
          id: 'ForgotPassword_1',
        },
      ],
      type: 'selectable',
    },
    appBar: {
      components: [
        {
          type: 'AppBar',
          id: 'AppBar_1',
        },
      ],
      type: 'selectable',
    },
    bottomBar: {
      components: [
        {
          type: 'BottomBar',
          id: 'BottomBar_1',
        },
      ],
      type: 'selectable',
    },
    generalStyle: {
      type: 'selectable',
    },
    Notification: {
      components: [
        {
          type: 'Notification',
          id: 'Notification_1',
        },
      ],
      type: 'selectable',
    },
    'Popup_dfcef17a-3b44-4070-b942-d4c018401d45 ': {
      components: [
        {
          type: 'Popup',
          id: 'Popup_1',
        },
      ],
      type: 'selectable',
      customPageType: 'Popup',
      name: 'Popup Sayfası 1',
    },
    'Popup_5aadd56b-ea32-4297-9df3-358db47c8dcc': {
      components: [
        {
          type: 'Popup',
          id: 'Popup_1',
        },
      ],
      type: 'selectable',
      customPageType: 'Popup',
      name: 'Popup Sayfası 2',
    },
    'Popup_5cc33448-ea66-48a3-8043-0b880b2c5d0c': {
      components: [
        {
          type: 'Popup',
          id: 'Popup_1',
        },
      ],
      type: 'selectable',
      customPageType: 'Popup',
      name: 'Popup Sayfası 3',
    },
    QuickBuyModal: {
      components: [
        {
          type: 'QuickBuyModal',
          id: 'QuickBuyModal_1',
        },
      ],
      type: 'selectable',
    },
  },
};

export default mockComponents;
